export default "__VITE_ASSET__BsZr1rEm__"